import {Component} from '@angular/core';

export const CARD_ACTIVATION_ICON_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path fill="#009688" fill-rule="evenodd" d="M28.432 5H3.407A2.457 2.457 0 0 0 1 7.5v16.697a2.457 2.457 0 0 0 2.407 2.5h25.025a2.457 2.457 0 0 0 2.407-2.5V7.5A2.457 2.457 0 0 0 28.432 5zM2.066 10.644h27.707v2.434H2.066v-2.434zm26.37 14.979H3.406a1.37 1.37 0 0 1-1.338-1.394V14.185h27.704V24.23a1.37 1.37 0 0 1-1.338 1.394zM2.065 9.538V7.5a1.37 1.37 0 0 1 1.338-1.394h25.028A1.37 1.37 0 0 1 29.77 7.5v2.038H2.066zm1.812 6.343H8.78v1.107H3.881V15.88h-.003zm6.394 0h4.902v1.107h-4.902V15.88zm6.394 0h4.901v1.107h-4.901V15.88zm6.393 0h4.899v1.107h-4.899V15.88z"/>
</svg>

`;

@Component({
    selector: 'tfl-card-activation-icon',
    template: CARD_ACTIVATION_ICON_SVG
})
export class CardActivationIcon {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/icons/card.activation.icon.ts